import AboutImg from "../../shared/assets/images/aboutUs.png";
import ArrowUp from "../../shared/assets/images/ArrowUp.png";
import { useState } from "react";
import Title from "../../shared/ui/Title/Title";
import ParagraphSection from "../../shared/ui/ParagraphSection/ParagraphSection";
import cls from "./About.module.css";
import MarginBottomContainer from "../../shared/ui/MarginBottomContainer/MarginBottomContainer";
import ScrollButton from "../../shared/ui/ScrollButton/ScrollButton";
const AboutUs = () => {
    const [visible, setVisible] = useState(false)
    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 800) {
            setVisible(true)
        }
        else if (scrolled <= 300) {
            setVisible(false)
        }
    };


    window.addEventListener('scroll', toggleVisible);

    return (
        <div id="aboutUs" className="about-section">
            <div style={{ display: visible ? "flex" : "none" }} className={cls.up} onClick={() => window.location.href = "#main"}>
                <ScrollButton src={ArrowUp} />
            </div>
            <div className="container container--main">
                <div className={cls.aboutWrapper}>
                    <MarginBottomContainer margin={22}>
                        <Title title="About Us" />
                    </MarginBottomContainer>

                    <MarginBottomContainer margin={90}>
                        <div className={cls.aboutWrapper__info}>
                            <div style={{ flexBasis: "50%", marginRight: "33px" }}>
                                <ParagraphSection>
                                    We are a dedicated team of performance marketers and conversion specialists, focused on scaling brands with strategic online advertising. With years of expertise in paid traffic, we design full-funnel campaigns that deliver real ROI.
                                </ParagraphSection>
                            </div>

                            <div style={{ flexBasis: "50%" }}>
                                <ParagraphSection>
                                    Our approach is driven by data, automation, and measurable outcomes, not assumptions or impressions. We turn digital advertising into a scalable growth engine for our clients.
                                </ParagraphSection>
                            </div>
                        </div>
                    </MarginBottomContainer>
                    <div className={cls.aboutWrapper__image}>
                        <img className="img" src={AboutImg} alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;
